import { render } from "./PersonalizedAdvice.vue?vue&type=template&id=065fd5a4"
import script from "./PersonalizedAdvice.vue?vue&type=script&lang=js"
export * from "./PersonalizedAdvice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__